(() => {
  const selector='[data-choice-hero]';
  const ready=new WeakSet();

  function init(root){
    if(ready.has(root)) return;
    ready.add(root);

    const cf=root.querySelector('[data-choice-coverflow]');
    if(!cf) return;

    const cards=[...cf.querySelectorAll('[data-choice-card]')];
    const dots=[...cf.querySelectorAll('[data-choice-dots] button')];
    const prev=cf.querySelector('[data-choice-prev]');
    const next=cf.querySelector('[data-choice-next]');
    const n=cards.length;
    if(!n) return;

    let active=0;
    let timer;
    let x0=null;
    let swiped=false;

    function layout(){
      const step=window.innerWidth<990?158:(window.innerWidth<=1200?188:232);
      cards.forEach((card,i)=>{
        let d=((i-active+n+1)%n)-1;
        if(n===3 && d===2) d=-1;
        const ad=Math.abs(d);
        const scale=ad===0?1:.82;
        card.style.transform='translateX('+(d*step)+'px) scale('+scale+')';
        card.style.zIndex=10-ad;
        card.style.opacity=ad>1?'0':'1';
        card.style.pointerEvents=ad>1?'none':'auto';
        card.style.filter=ad===0?'none':'brightness(.58)';
        card.classList.toggle('is-on',ad===0);
        card.setAttribute('aria-current',ad===0?'true':'false');
      });
      dots.forEach((dot,i)=>dot.classList.toggle('is-on',i===active));
    }

    function go(i){
      active=(i+n)%n;
      layout();
    }

    function auto(){
      clearInterval(timer);
      timer=setInterval(()=>go(active+1),5000);
    }

    cards.forEach((card,i)=>{
      card.addEventListener('click',()=>{
        if(swiped){swiped=false;return;}
        if(i===active){
          const selector=root.dataset.entryTarget||'#entry-packages';
          const target=document.querySelector(selector);
          if(target) target.scrollIntoView({behavior:'smooth',block:'start'});
        } else {
          go(i);
          auto();
        }
      });
    });

    dots.forEach((dot,i)=>dot.addEventListener('click',()=>{go(i);auto();}));
    prev?.addEventListener('click',()=>{go(active-1);auto();});
    next?.addEventListener('click',()=>{go(active+1);auto();});

    cf.addEventListener('pointerdown',e=>{x0=e.clientX;swiped=false;});
    cf.addEventListener('pointerup',e=>{
      if(x0===null) return;
      const dx=e.clientX-x0;
      x0=null;
      if(Math.abs(dx)>40){
        swiped=true;
        go(active+(dx<0?1:-1));
        auto();
      }
    });

    window.addEventListener('resize',layout);
    layout();
    auto();
  }

  const scan=()=>document.querySelectorAll(selector).forEach(init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',scan,{once:true});
  else scan();
  document.addEventListener('shopify:section:load',scan);
})();